<section
  id="main-container"
  class="relative overflow-hidden rounded-3xl lg:rounded-xl h-fit w-full bg-cover bg-center"
  style="background-image: url(&quot;images/background/monet-bg.png&quot;)"
>
  <!-- Soft overlay to keep text legible over the painting -->
  <div class="absolute inset-0 bg-white/35"></div>

  <div id="container" class="relative h-full w-full p-6" #qrContainer>
    <div class="relative">
      <div id="button" class="flex justify-end">
        <button
          (click)="closeDialog()"
          class="flex items-center justify-center w-9 h-9 rounded-full bg-white/90 shadow-md hover:bg-white transition-colors"
        >
          <mat-icon
            class="w-5 h-5 text-slate-600"
            [svgIcon]="'heroicons_outline:x-mark'"
          ></mat-icon>
        </button>
      </div>
    </div>

    <div id="logo-container" class="flex justify-center pt-1 pb-6">
      <img
        src="images/Logo-AEM-Green.png"
        class="w-36"
        alt="AEM Enersol Logo"
      />
    </div>

    <div class="flex justify-center">
      <div
        id="qrcode-container"
        class="relative bg-white/75 backdrop-blur-sm ring-1 ring-white/60 rounded-3xl shadow-lg p-4"
      >
        <!-- Corner brackets (radius matches the container) -->
        <span
          class="absolute top-2 left-2 w-7 h-7 border-t-2 border-l-2 border-cyan-700/50 rounded-tl-3xl"
        ></span>
        <span
          class="absolute top-2 right-2 w-7 h-7 border-t-2 border-r-2 border-cyan-700/50 rounded-tr-3xl"
        ></span>
        <span
          class="absolute bottom-2 left-2 w-7 h-7 border-b-2 border-l-2 border-cyan-700/50 rounded-bl-3xl"
        ></span>
        <span
          class="absolute bottom-2 right-2 w-7 h-7 border-b-2 border-r-2 border-cyan-700/50 rounded-br-3xl"
        ></span>

        <div
          class="relative flex justify-center items-center overflow-hidden rounded-2xl"
        >
          <qrcode
            class="flex justify-center items-center"
            [qrdata]="this.businessCardUrl"
            [width]="210"
            colorLight="#ffffff"
            [errorCorrectionLevel]="'H'"
          ></qrcode>

          <!-- Center AEM badge -->
          <div
            class="absolute flex items-center justify-center w-11 h-11 rounded-full bg-white shadow-md ring-2 ring-white"
          >
            <img
              src="images/logo/AEM-Plus-dark-24px.svg"
              class="size-6"
              alt="AEM"
            />
          </div>
        </div>
      </div>
    </div>

    <h1
      id="name"
      class="mt-8 text-2xl text-center font-extrabold tracking-wide text-cyan-800"
    >
      {{ profile.givenName | uppercase }}
    </h1>

    <p
      id="jobTitle"
      class="mt-1 text-center text-sm font-bold tracking-widest text-slate-700"
    >
      {{ profile.jobTitle | uppercase }}
    </p>

    <div class="flex justify-center my-3">
      <span class="block h-0.5 w-10 rounded-full bg-cyan-700"></span>
    </div>

    <p
      id="description"
      class="mb-6 px-6 text-center text-sm font-medium text-slate-700"
    >
      Scan this QR code to add me to your network.
    </p>

    <div id="button" class="grid grid-cols-2 gap-3 pb-1">
      <button
        (click)="share()"
        class="inline-flex items-center justify-center gap-2 rounded-xl bg-white shadow-md py-2.5 hover:bg-slate-50 transition-colors"
      >
        @if (isLoading) {
          <div role="status">
            <svg
              aria-hidden="true"
              class="w-5 h-5 animate-spin text-slate-300 fill-cyan-700"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        } @else {
          <mat-icon
            class="w-4 h-4 text-slate-600"
            [svgIcon]="'heroicons_outline:share'"
          ></mat-icon>
          <span class="text-slate-700 text-sm font-semibold leading-5"
            >Share</span
          >
        }
      </button>

      <button
        (click)="navigateToBusinessCard()"
        class="inline-flex items-center justify-center gap-2 rounded-xl bg-cyan-800 shadow-md py-2.5 hover:bg-cyan-900 transition-colors"
      >
        <mat-icon
          class="w-4 h-4 text-white"
          [svgIcon]="'heroicons_outline:identification'"
        ></mat-icon>
        <span class="text-white text-sm font-semibold leading-5"
          >Show card</span
        >
      </button>
    </div>
  </div>
</section>
